// Shared utilities for Campaigns Phase 2 — token renderer, headers, helpers.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL;

export const buildHeaders = (session) => ({
  "x-tenant-id": session?.tenant?.id || "tenant_1",
  "x-user-id": session?.user?.id || "admin",
  "x-user-role": session?.user?.role || "admin",
  "Content-Type": "application/json",
});

export const formatDeadline = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso + "T00:00:00Z");
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return iso; }
};

export const TOKENS = [
  { key: "{{school_name}}", label: "School name" },
  { key: "{{leader_name}}", label: "Leader name" },
  { key: "{{leader_role}}", label: "Leader role" },
  { key: "{{campaign_name}}", label: "Campaign name" },
  { key: "{{deadline}}", label: "Deadline" },
  { key: "{{state}}", label: "State" },
  { key: "{{calendly_url}}", label: "Calendly URL" },
];

export const renderTokens = (template, ctx = {}) => {
  if (!template) return "";
  return TOKENS.reduce(
    (s, t) => s.split(t.key).join(ctx[t.key.replace(/[{}]/g, "")] || ""),
    template,
  );
};

export const STATUS_COLOR = {
  queued: { bg: "#f1f5f9", fg: "#475569" },
  booked: { bg: "#dbeafe", fg: "#1d4ed8" },
  opened: { bg: "#fef3c7", fg: "#a16207" },
  replied: { bg: "#dcfce7", fg: "#15803d" },
};
